<div class="dark-mode">
    <div class="row">
        <div class="col-6 col-sm-6 col-md-6 text-end">
            <div class="d-flex" style="gap: 10px">
                <mat-form-field class="mb-1 w-100" appearance="outline" >
                    <mat-icon matPrefix>search</mat-icon>
                    <input type="text" placeholder="Search" matInput [(ngModel)]="pageQuery.search" (keyup)="searchUser($event)">
                    <mat-icon (click)="clearSearch()" *ngIf="showCloseSearch && pageQuery.search.length > 0" class="button-flat" matSuffix>close</mat-icon>
                </mat-form-field>
                <button class="add-new-button" (click)="addNewDomain()" mat-raised-button >
                    <mat-icon>add</mat-icon>
                    Add New
                </button>
            </div>

        </div>
    </div>

    <div class="table-responsive-dark list-wrapper-bordered-dark">
        <table class="table table-striped table-hover table-bordered ">
            <thead>
            <tr>
                <th class="text-nowrap">ID</th>
                <th class="text-nowrap">Domain Name</th>
                <th class="text-nowrap">Target Objectives</th>
                <th class="sticky-action"></th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngIf="domains.length > 0">
                <tr *ngFor="let domain of domains">
                    <td class="text-start" style="vertical-align: top;">
                        {{domain.id}}
                    </td>
                    <td class="text-start" style="vertical-align: top;">
                        {{domain.domainName}}
                    </td>
                    <td class="text-start">
                        <ul>
                            <ng-container *ngFor="let obj of domain.objectives; let i = index;">
                                <li *ngIf="i < 3">{{obj.objectiveName}}</li>
                            </ng-container>
                        </ul>
                        <span class="text-color-black-normal-50" *ngIf="domain.objectives.length > 3"> [+ {{domain.objectives.length - 3}} More]</span>
                    </td>
                    <td class="text-center p-1 action-column"  style="width: 140px; vertical-align: top;">
                        <div class="d-flex gap-3 justify-content-center">
                            <mat-icon class="text-white mr-2" (click)="detailDomain(domain.id)">arrow_forward</mat-icon>
                            <mat-icon class="mr-2 accent-orange" (click)="editDomain(domain.id)">edit</mat-icon>
                            <mat-icon class="crimson-red" (click)="deleteDomain(domain.id)">delete</mat-icon>
                        </div>

                    </td>
                </tr>
            </ng-container>

            <tr *ngIf="domains.length == 0">
                <td colspan="4" class="text-center">
                    <span>{{tableLoading ? 'Load data...' : 'No Record'}}</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="domains.length > 0">
        <app-pagination-dark
                (goPage)="toPage($event)"
                (goPerPage)="perPageSet($event)"
                [pagesToShow]="showPages"
                [page]="pageNo"
                [perPage]="pageSize"
                [count]="totalRow"></app-pagination-dark>
    </div>
</div>

